import React from 'react';
import { IoMdSunny, IoMdMoon } from "react-icons/io";
import useEditorStore from '../store/useEditorStore';

const ThemeSwitcher: React.FC = () => {
  const { isDarkMode, toggleTheme } = useEditorStore();

  return (
    <button
      onClick={toggleTheme}
      title={isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
      className="flex h-8 w-8 items-center justify-center rounded-lg text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white"
    >
      {isDarkMode ? <IoMdSunny size={16} /> : <IoMdMoon size={16} />}
    </button>
  );
};

export default ThemeSwitcher;
